
import { BaseView } from "@root/components";
import { Component, Vue } from "vue-property-decorator";
import { ProjectView } from "@/views/project-view";

@Component
export default class Form extends ProjectView {
    toggle: boolean = true;
    get form_inf() {
        return require("raw-loader!./../Form/FormCore/form-core.interface").default;
    }
}
